// extracted by mini-css-extract-plugin
module.exports = {"menu-link":"style_menu-link__1jLJh","menu-link--active":"style_menu-link--active__3PWBm"};